
define('ldsh!modules/form_editor/templates/notice_view', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-notice-inner">\n  <div class="flex align-center justify-space-between">\n    <h4 class="ed-notice-head">' +
((__t = ( title )) == null ? '' : __t) +
'</h4>\n    <i class="js-close-notice ri-close-line f24 pointer"></i>\n  </div>\n  <p>' +
((__t = ( message )) == null ? '' : __t) +
'</p>\n</div>\n';

}
return __p
};});

